import React from "react";
import { Authentication, User } from "./User";
import { OrderByDirection, WhereFilterOp } from "firebase/firestore";

export interface OrderInterface {
    key: string
    direction: OrderByDirection
}

export interface FiltersInterface {
    key: string
    operator: WhereFilterOp
    value: any
}

export interface UserContextModel {
    user: User;
    authenticate:Authentication;
    dataCopy : any 
    assignateCopyData: (data: any) => void;
    getDocuments$: (
        filters: FiltersInterface[], 
        orderType?: OrderInterface,
        limit?: number) => void;
    assignateAuth :(id:any, authenticate:boolean, token: string)=>void;
    assignUser: (id:string, lastName:string, name:string, email:string)=> void;
    navigateToSegment: (navigate:any) => void
    separatorMiles: (value: number) => string
}

const UserContextP = React.createContext<UserContextModel>({
    user: { id:"", name:"", lastName:"", email:""},
    authenticate :{uid:'', auth:false, token: ""},
    dataCopy:{},
    assignateCopyData: ()=>{},
    getDocuments$ : ()=>{},
    assignateAuth : ()=>{},
    assignUser : ()=>{},
    navigateToSegment: () => { },
    separatorMiles: () => "",
})

export default UserContextP;